import React from "react"
import styles from "./styles.scss"

const Quote = ({ quote, image, authorPosition, author }) => (
  <div className={styles.container}>
    <div className={styles.imageWrapper}>
      <img
        className={styles.image}
        src={image}
        alt={`Citatets källa, ${author}, ${authorPosition}`}
      />
    </div>

    <p className={styles.content}>{quote}</p>
  </div>
)

export default Quote



// WEBPACK FOOTER //
// ./src/pages/LandingPage/CaseStudySection/Quote/index.jsx